<template>
  <tr class="divide-x divide-static-default-low">
    <td class="py-12 body-2-bold pr-16">
      {{ firstColumn }}
    </td>
    <td class="py-12 body-2-bold">
      <div class="p-16">
        {{ secondColumn }}
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
defineProps<{
  firstColumn: string
  secondColumn?: string
}>()
</script>
